var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.77 129.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.77,
    height: 129.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.42,82.6l2.99-19.51h-18.72v-12.66c0-5.34,2.61-10.54,11-10.54h8.51v-16.61s-7.72-1.32-15.11-1.32c-15.42,0-25.5,9.34-25.5,26.26v14.87h-17.14v19.51h17.14v47.17h21.09v-47.17h15.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFb2);
export default __webpack_public_path__ + "static/media/ico-fb-2.8e550b4f8abe100ca871d10e43024c6f.svg";
export { ForwardRef as ReactComponent };